export const CARBURETION_ACTIONS = {
  SEARCH_INPUTS: "SEARCH_INPUTS",
  GET_CARBURATIONS: "GET_CARBURATIONS",
  ADD_CARBURATION: "ADD_CARBURATION",
  EDIT_CARBURATION: "EDIT_CARBURATION",
  DELETE_CARBURATION: "DELETE_CARBURATION",
  SELECT_CARBURATION: "SELECT_CARBURATION",
  UPDATE_CARBURETION_DATE: "UPDATE_CARBURETION_DATE",
  RESTORE_INITIAL: 'RESTORE_INITIAL',
  GET_UNIT_CONFIGS: "GET_UNIT_CONFIGS",
  UPDATE_UNIT_CONFIG_FILLING_ORDER: 'UPDATE_UNIT_CONFIG_FILLING_ORDER',
};
